<template>
  <a-modal
    destroyOnClose
    :footer="null"
    :maskClosable="false"
    centered
    :title="refundable?$t('title.returnPickUp'):$t('title.asnPickup')"
    v-model="visible"
    width="80%"
  >
    <a-space>
      <a-input-search
        class="query"
        @pressEnter="searchOrder"
        @search="searchOrder"
        :placeholder="refundable?$t('business.label.returnOrderNo'):$t('business.label.asnOrderNo')"
        v-model="orderQuery['no']"
      />
      <a-input-search
        class="query"
        @pressEnter="searchOrder"
        @search="searchOrder"
        :placeholder="refundable?$t('business.label.returnCustomer'):$t('business.label.supplierName')"
        v-model="orderQuery['customer.name']"
      />
      <a-select v-model="orderQuery['storer.id']" :placeholder="$t('business.label.storer')" allowClear class="query">
        <a-select-option v-for="d in storerData" :key="d.id">{{ d.name }}</a-select-option>
      </a-select>
      <a-button @click="searchOrder" type="primary">{{ $t('button.query') }}</a-button>
      <a-button @click="confirm" type="primary">{{ $t('button.confirm') }}</a-button>
      <a-button @click="reset" type="primary">{{ $t('button.reset') }}</a-button>
    </a-space>
    <br /><br />
    <vxe-table
      border
      stripe
      round
      show-overflow
      show-header-overflow
      :export-config="{}"
      :keyboard-config="{isArrow: true}"
      align="center"
      ref="orderTable"
      :data="orderData"
      :loading="orderLoading"
      size="mini"
      :height="250"
      :scroll-x="{enabled: true}"
      :row-config="{isCurrent: true, isHover: true}"
      :column-config="{resizable: true}"
      @cell-click="onClickOrderRow">
      <vxe-column fixed="left" type="seq" width="40"/>
      <vxe-column :title="refundable?'business.label.returnOrderNo':'business.label.asnOrderNo'" field="order.no" width="120" />
      <vxe-column field="storer.name" title="business.label.storer" width="100" />
      <vxe-column field="order.invoiceTime" title="business.label.invoiceTime" width="170"/>
      <vxe-column field="order.orderStatus" title="business.label.orderStatus" width="100">
        <span slot-scope="{ row }">{{ orderStatusData.find(item => item.ordinal === row.order.orderStatus).name }}</span>
      </vxe-column>
      <vxe-column :title="refundable?'business.label.returnType':'business.label.orderType'" field="orderType.name" width="120" />
    </vxe-table>
    <vxe-pager :current-page="orderPage" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" :loading="orderLoading" :page-size="orderSize" :total="orderContentSize" size="mini" style="height: 24px" @page-change="pageChange"/>
    <a-space>
      <a-input-search v-model="detailQuery['item.no']" :placeholder="$t('business.label.itemNo')" class="query" @pressEnter="searchDetail" @search="searchDetail" />
      <a-input-search v-model="detailQuery['item.name']" :placeholder="$t('business.label.itemName')" class="query" @pressEnter="searchDetail" @search="searchDetail" />
      <a-input-search v-model="detailQuery['item.barcodes']" :placeholder="$t('business.label.itemBarcode')" class="query" @pressEnter="getDetailData()" @search="getDetailData()" />
    </a-space>
    <br /><br />
    <vxe-table
      border
      stripe
      round
      show-overflow
      show-header-overflow
      :export-config="{}"
      :keyboard-config="{isArrow: true}"
      align="center"
      ref="detailTable"
      :data="detailData"
      :loading="detailLoading"
      size="mini"
      :height="300"
      :scroll-x="{enabled: true}"
      :row-config="{isCurrent: true, isHover: true}"
      :column-config="{resizable: true}"
      @cell-dblclick="onDblClickDetailRow">
      <vxe-column fixed="left" type="seq" width="40"/>
      <vxe-column field="item.no" title="business.label.itemNo" width="80" />
      <vxe-column field="item.name" title="business.label.itemName" width="200" />
      <vxe-column field="pack.specification" title="business.label.specification" width="200" />
      <vxe-column field="pack.uom" title="business.label.uom" width="60"/>
      <vxe-column field="pack.factor" title="business.label.factor" width="60"/>
      <vxe-column field="asnDetail.lotNo" title="business.label.lot" width="200" />
      <vxe-column field="asnDetail.productionDate" title="business.label.productionDate" width="100" />
      <vxe-column field="asnDetail.validUntil" title="business.label.validUntil" width="100" />
      <vxe-column field="asnDetail.manufacturer" title="business.label.manufacturer" width="150" />
      <vxe-column field="asnDetail.producingArea" title="business.label.producingArea" width="150" />
      <vxe-column field="asnDetail.approvalNo" title="business.label.approvalNo" width="150" />
      <vxe-column field="asnDetail.quantity" title="business.label.totalQuantity" width="100" />
      <vxe-column :title="refundable?'business.label.acceptedQuantity':'business.label.receivedQuantity'" field="asnDetail.receivedQuantity" width="150" />
      <vxe-column v-if="!refundable" field="asnDetail.acceptedQuantity" title="business.label.acceptedQuantity" width="150" />
      <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="supervised" title="business.label.supervised" width="70"/>
    </vxe-table>
    <vxe-pager :current-page="detailPage" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" :loading="detailLoading" :page-size="detailSize" :total="detailContentSize" size="mini" @page-change="detailPageChange" />
  </a-modal>
</template>
<script>
import moment from 'moment'
import { findAll } from '@/api/Api'

export default {
    name: 'ReceiptPickupModal',
    data() {
      return {
        visible: false,
        orderLoading: false,
        detailLoading: false,
        orderData: [],
        detailData: [],
        orderSize: 5,
        orderPage: 1,
        orderContentSize: 0,
        orderQuery: {
          'no': '',
          'customer.name': '',
          'storer.id': undefined,
          'extract': true,
          'refundable': this.refundable
        },
        detailQuery: {
          'item.no': '',
          'item.name': '',
          'item.barcodes': ''
        },
        detailPage: 1,
        detailSize: 5,
        detailContentSize: 0
      }
    },
    props: {
      selectType: {
        type: String,
        default: 'radio'
      },
      title: {
        type: String,
        default: 'ASN提取'
      },
      refundable: {
        type: Boolean,
        default: false
      },
      orderStatusData: {
        type: Array,
        default: []
      },
      storerData: {
        type: Array,
        default: []
      }
    },
    methods: {
      moment,
      init(args) {
        this.orderQuery = {
          'no': '',
          'customer.no': '',
          'storer.id': undefined,
          'extract': true,
          'refundable': this.refundable
        }
        this.detailQuery = {
          'item.no': '',
          'item.name': '',
          'item.barcodes': ''
        }
        this.orderData = []
        this.detailData = []
        this.orderPage = 1
        this.orderSize = 5
        this.orderContentSize = 0
        this.detailPage = 1
        this.detailSize = 5
        this.detailContentSize = 0
        if (args !== null && args !== undefined) {
          this.args = args
          Object.assign(this.orderQuery, args)
        } else {
          this.args = null
        }
      },
      open(args) {
        this.init(args)
        this.visible = true
      },
      pageChange({ currentPage, pageSize }) {
        this.orderPage = currentPage
        this.orderSize = pageSize
        this.getData()
      },
      detailPageChange({ currentPage, pageSize }) {
        this.detailPage = currentPage
        this.detailSize = pageSize
        this.getDetailData()
      },
      getData() {
        this.orderLoading = true
        findAll('receivingAsnListFactory', this.orderQuery, this.orderPage, this.orderSize)
          .then((res) => {
            if (res.success) {
              setTimeout(() => {
                this.orderContentSize = res.contentSize
                this.orderData = res.result
                this.detailData = []
                this.orderLoading = false
              }, 200)
            }
          })
      },
      getDetailData() {
        let currentRow = this.$refs.orderTable.getCurrentRecord()
        if (currentRow === null) {
          return this.$message.warning('请先选择单据')
        }
        this.detailLoading = true
        const args = Object.assign({}, this.detailQuery)
        args.no = currentRow.order.no
        findAll('asnDetailFactory', args, this.detailPage, this.detailSize).then((res) => {
          if (res.success) {
            this.detailData = res.result
            this.detailContentSize = res.contentSize
          }
        }).finally(() => {
          this.detailLoading = false
        })
      },
      onClickOrderRow() {
        this.getDetailData()
      },
      onDblClickDetailRow() {
        this.confirm()
      },
      clearParam() {
        this.init(this.args)
      },
      handleCancel() {
        this.visible = false
      },
      confirm() {
        let currentOrder = this.$refs.orderTable.getCurrentRecord()
        let currentDetail = this.$refs.detailTable.getCurrentRecord()
        if (currentOrder === null) {
          return this.$message.warning('请选择单据以及明细')
        }
        if (currentDetail === null) {
          return this.$message.warning('请选择明细')
        }
        const asnOrder = Object.assign({}, currentOrder.order)
        asnOrder.orderType = Object.assign({}, currentOrder.orderType)
        asnOrder.storer = Object.assign({}, currentOrder.storer)
        asnOrder.customer = Object.assign({}, currentOrder.customer)
        asnOrder['details'] = [Object.assign({}, currentDetail)]
        this.$emit('change', asnOrder)
        this.visible = false
      },
      searchOrder() {
        this.orderPage = 1
        this.getData()
      },
      searchDetail() {
        this.detailPage = 1
        this.getDetailData()
      },
      cancel() {
        this.visible = false
      },
      reset() {
        this.init(this.args)
        this.searchOrder()
      }
    }
  }
</script>
<style scoped>
  .query {
    width: 200px;
  }

  .ant-table td {
    white-space: nowrap;
  }
</style>